import moment from 'moment';

export default class MessageFormatter {

  constructor() {}

  getApprovePeriodsInitialMessage(periods, additionalText='') {
    return `${periods.length} ${additionalText}`
      + '</br>'
      + '</br>';
  }

  getApprovePeriodMessage(period, singleDaysText='', positiveDaysDifferenceText='', negativeDaysDifferenceText='', isMobileApp) {
    const month = this.getMonthInTextFormat(period.enjoymentMonth);
    let message = `${period.name} -`
      + ` ${this.getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText)}`
      + ` ${month}`
      + ' </br>';
    if (isMobileApp) {
      message = `${period.name}`
        + ' </br>'
        + ` ${this.getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText)}`
        + ` ${month}`
        + ' </br>'
        + ' </br>';
    }
    return message;
  }

  getApproveSinglePeriodMessage(period, singleDaysText='', positiveDaysDifferenceText='', negativeDaysDifferenceText='') {
    const month = this.getMonthInTextFormat(period.enjoymentMonth);
    return `<span class="period-name">${period.name}</span>`
      + ' </br>'
      + ` ${this.getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText)}`
      + ` ${month}`;
  }

  getMonthInTextFormat(month) {
    return moment().month(month - 1).format('MMMM');
  }

  getDays(period, singleDaysText, positiveDaysDifferenceText, negativeDaysDifferenceText) {
    const daysDifference = parseInt(period.daysDifference, 10) || 0;

    if (period.enjoymentDays - period.approvedDays > 0) {
      return `${period.enjoymentDays - period.approvedDays} ${positiveDaysDifferenceText}`;
    } else if (daysDifference === 0) {
      return `${period.enjoymentDays} ${singleDaysText}`;
    } else {
      return `${period.approvedDays - period.enjoymentDays} ${negativeDaysDifferenceText}`;
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/formatters/messageFormatter.js